import Vue from 'vue';
import VueRouter from 'vue-router';

import store from '../store';

// import { purechatApi } from "@/purechatApi";
import { pureChatPages } from "@/constants/purechatConstants";

const ShopView = () => import('../sections/shop/View_Shop');
const WindowShop = () => import("@/sections/shop/windowShop/Page_WindowShop");
const WindowShopWindow = () => import("@/sections/shop/windowShop/Page_WindowShopWindow");
const ShopListing = () => import("@/sections/shop/category/Page_ShopListing");
const SubcategoryListing = () => import('../sections/shop/category/Page_CategoryListing');
const Specials = () => import('../sections/shop/specials/Page_SpecialsListing');
const ProductListing = () => import('../sections/shop/listing/Page_Listing');
const Product = () => import('../sections/shop/product/Page_Product');

const Login = () => import('../sections/login/Page_Login');
const ResetPassword = () => import('../sections/login/Page_ResetPassword.vue');

const ForgottenPassword = () => import('../sections/login/Page_ForgottenPassword');
const Signup = () => import('../sections/signup/Page_Signup');
const VerifyEmail = () => import('../sections/signup/Page_VerifyEmail');
const CheckEmail = () => import('../sections/signup/Page_CheckEmails');


const SearchResults = () => import('../sections/search/Page_AlgoliaSearchResults');

const Brands = () => import('../sections/brands/Page_Brands');
const Brand = () => import('../sections/brands/Page_Brand');
const NZBrands = () => import('../sections/brands/Page_NZ_Brands');

const MemberBiz = () => import('../sections/benefits/MemberBiz/Page_MemberBiz.vue');
const MemberBizListing = () => import('../sections/benefits/MemberBiz/Page_MemberBizListing.vue');
const MemberBizSingle = () => import('../sections/benefits/MemberBiz/Page_SingleMemberBiz.vue');

const DiscountPartners = () => import('../sections/benefits/DiscountPartners/Page_DiscountPartners.vue');
const DiscountPartnerListing = () => import('../sections/benefits/DiscountPartners/Page_DiscountPartnerListing.vue');
const DiscountPartnerSingle = () => import('../sections/benefits/DiscountPartners/Page_SingleDiscountPartner.vue');

const Renovations = () => import('../sections/benefits/Renovations/Page_Renovations');

//Logged in user elements loaded when required
const CompleteAccount = () => import('../sections/myAccount/Page_CompleteAccount');
const MyAccount = () => import('../sections/myAccount/Page_MyAccount');
const Details = () => import('../sections/myAccount/Details');
const Preferences = () => import('../sections/myAccount/Preferences');
const Purchases = () => import('../sections/myAccount/Purchases');
const Referrals = () => import('../sections/myAccount/Referrals');
const Membership = () => import('../sections/myAccount/Membership');
const Points = () => import('../sections/myAccount/Points');
const Favourites = () => import('../sections/myAccount/Favourites');
const GoldUpgrade = () => import("../sections/myAccount/GoldUpgrade");
const MembershipRenewal = () => import("../sections/myAccount/MembershipRenewal");
const ChangePassword = () => import("../sections/myAccount/ChangePassword");

const PriceRequest = () => import('../sections/priceRequest/Page_PriceRequest');


const Cart = () => import('../sections/shop/cart/Page_Cart');
const Payment = () => import('../sections/shop/checkout/Page_Payment');
const Returns = () => import('../sections/shop/returns/Returns');

const ContactPage = () => import("../sections/contact/Page_Contact");
// const FeedbackPage = () => import("../sections/contact/Page_Feedback");
const PetSubmissionPage = () => import("../sections/contact/Page_PetContest");
const RejoinRequestPage = () => import("../sections/contact/Page_RejoinRequest");


//const AcceptDocument = () => import('@/wordpress/components/AcceptDocument')
const WordpressGetter = () => import(/* webpackPrefetch: true */'../wordpress/WordpressContentPage');
const WordpressPreviewGetter = () => import('../wordpress/WordpressContentPage-Previews');
const PageNotFound = () => import('@/sections/Page_NotFound');
const Blog = () => import('@/wordpress/blog/BlogPage');
const BlogPost = () => import('@/wordpress/blog/BlogPost');

const EmptyView = () => import('../pageTemplates/View_Empty');


Vue.use(VueRouter)

const routes = [

	//required to allow home page to have child routes
	{ path: '/home', redirect: '/' },
	{
		path: '/', component: EmptyView, menu: { public: "Home", member: "Home" },
		children: [
			{ path: '', name: 'home', component: WordpressGetter, props: { pageSlug: 'new-home-page' } },
		]
		//     { path: 'silver-membership', component: WordpressGetter, props: { pageSlug: 'silver-membership' }, menu: { public: "Silver Membership", member: "Silver Membership"} },
		//     { path: 'gold-membership', component: WordpressGetter, props: { pageSlug: 'gold-membership' }, menu: { public: "Gold Membership", member: "Gold Membership" } },
		//     { path: 'platinum-membership', component: WordpressGetter, props: { pageSlug: 'platinum-membership' }, menu: { public: "Platinum Membership", member: "Platinum Membership" } },
		//     { path: 'earning-points', component: WordpressGetter, props: { pageSlug: 'earning-points' }, menu: { public: "Earning Points", member:"Earning Points" } },
		//     { path: 'best-membership-options', component: WordpressGetter, props: {pageSlug: 'best-membership-options'}, menu: { public: "Best Membership Options", member: "Best Membership Options"}}
		// ]
	}, //show homepage

	{ 
		path: '/window_shop', component: ShopView, menu: { public: "Window Shop" },
		children: [
			{ path: '', name: 'window-shop', component: WindowShop, props: { pageSlug: 'windowshop' } },
			{ path: 'big_ticket_items', name: 'big-ticket-items', component: WindowShopWindow, props: { pageSlug: 'windowshop-bigticket', cat: 1 } },
			{ path: 'baby_items', name: 'baby-items', component: WindowShopWindow, props: { pageSlug: 'windowshop-baby', cat: 2 } },
			{ path: 'build_reno_items', name: 'build-reno-items', component: WindowShopWindow, props: { pageSlug: 'windowshop-buildreno', cat: 3} },
			{ path: 'everyday_items', name: 'everyday-items', component: WindowShopWindow, props: { pageSlug: 'windowshop-everyday', cat: 4 } },
		]	
	},

	{   //shop section
		path: '/shop', component: ShopView, menu: { member: "Shop" }, meta: {breadcrumb: "Shop", requiresLogin: true},
		// path: '/shop', component: ShopView, menu: { public: "Window Shop" }, meta: {breadcrumb: "Shop"},
		children:
			[
				{ path: '', name: 'shop', component: ShopListing, props: { pageSlug: 'shopping' }}, //show shop home
				//{ path:'boagt', name:'boagt',component:WordpressGetter, props: {pageSlug:'boagt'},menu:{public:'Book of all Good Things',member:'Book of all Good Things'}},
				{ path: 'search', name: 'search', component: SearchResults },
				{ path: 'cart', component: Cart, name: 'cart' },
				{ path: 'payment', component: Payment, name: 'payment', props: true },
				//success page
				{ path: 'purchaseSuccess', component: WordpressGetter, name: 'purchaseSuccess', props: { pageSlug: 'purchaseSuccess' } },

				{ path: 'category/:category', name: 'category', component: SubcategoryListing }, //show sub categories
				{ path: 'specials', name: 'specials', component: Specials, meta: { breadcrumb: 'Specials'}},
				{ path: 'category/:category/subcategory/:subcategory', name: 'subcategory', component: ProductListing }, //show product listing
				{ path: 'item/:product', name: 'product', component: Product }, //show product
			]
	},

	{
		path: '/brands', component: EmptyView, menu: { public: 'Brands', member: 'Brands' }, meta: { breadcrumb: "Brands", flyover: true, flyoverContent: "brands"},
		children:
			[
				{ path: '', name: 'brands', component: Brands, menu: { public: 'All Brands', member: 'All Brands' }},
				{ path: 'nz_brands', name: 'nz-brands', component: NZBrands, props: { pageSlug: 'nz-brands' }, menu: { public: 'New Zealand Brands', member: 'New Zealand Brands' } },
				{ path: 'brand/:brand', name: 'brand', component: Brand },
				// { path: 'boagt', name: 'boagt', component: WordpressGetter, props: {pageSlug: 'boagt'},menu:{member:'Brands by Product Type'}},

			]

	},

	// Member only
	{ 
		path: '/reno_and_builds', component: EmptyView, menu: { public: 'Renovations', member: 'Renovations' },
		children: [
			{ path: '' , name: 'reno-and-builds', component: Renovations, props: { pageSlug: 'renos' } },
			{ path: 'kitchen', name: 'reno-and-builds-kitchen', component: WordpressGetter, props: { pageSlug: 'renos-kitchen' }, menu: { public: 'Kitchen Renovations', member: 'Kitchen Renovations' } },
			{ path: 'bathroom', name: 'reno-and-builds-bathroom', component: WordpressGetter, props: { pageSlug: 'renos-bathroom' }, menu: { public: 'Bathroom Renovations', member: 'Bathroom Renovations' } }
		]	 
	},
	{ path: '/baby_essentials', name: 'baby-essentials', component: WordpressGetter, props: { pageSlug: 'baby-info' }, menu: { member: "Baby Info" }, meta: { requiresLogin: true } },

	// Public Membership Links
	// { path: '/membership_options', name: 'membership-options', component: WordpressGetter, props: { pageSlug: 'membership-options' }, menu: { public: "Membership Options" } },
	// { path: '/member_testimonials', name: 'member-stories', component: WordpressGetter, props: { pageSlug: 'member-testimonials' }, menu: { public: "What our Members Say" } },

	// Member membership links
	{
		path: '/membership_options', component: EmptyView, menu: { public: 'Membership', member: "Membership"},
		children: [
			{ path: '', name: 'membership-options-submenu', component: WordpressGetter, props: { pageSlug: 'membership-options' }, menu: { public: "Membership Options", member: 'Membership Options' } },
			{ path: 'testimonials', name: 'member-stories', component: WordpressGetter, props: { pageSlug: 'member-testimonials' }, menu: { public: "What our Members Say", member: "What our Members Say" } },
			{ path: 'silver', name: 'membership-options-silver', component: WordpressGetter, props: { pageSlug: 'member-options-silver' }}
		]
	},
	// End Membership Links

	// { path: '/how_to', name: 'how-to', component: WordpressGetter, props: { pageSlug: 'using-this-site' }, menu: { member: 'How to use this site' } },

	{
		path: '/partners', component: EmptyView, menu: { member: "Partners" }, meta: { breadcrumb: "Partners", requiresLogin: true  },
		children: [
			{ path: '', redirect: 'member_biz' },
			{
				path: 'member_biz', component: EmptyView, menu: { member: "Member Biz Partners" }, meta: { breadcrumb: "Member Biz", requiresLogin: true  },

				children: [
					{ path: '', name: 'memberBiz', component: MemberBiz },
					{ path: 'location/:location', name: 'memberBizLocation', component: MemberBizListing },
					{ path: 'single/:memberBiz', name: 'memberBizSingle', component: MemberBizSingle }
				]
			},
			{
				path: 'discount_partners', component: EmptyView, menu: { member: "National Discount Partners" }, meta: { breadcrumb: "Discount Partners", requiresLogin: true  },
				children: [
					{ path: '', name: 'discountPartners', component: DiscountPartners },
					{ path: 'location/:location', name: 'discountPartnerLocation', component: DiscountPartnerListing },
					{ path: 'single/:discountPartner', name: 'discountPartnerSingle', component: DiscountPartnerSingle }
				]
			},

			// { path: 'discount-partners', name: 'discountPartners', component: DiscountPartners, menu: { public: 'Discount Partners', member: "Discount Partners" } },
			// { path: 'home-renovations', component: EmptyView, menu: { public: 'Home Renovations', member: "Home Renovations" },
			// children:[
			// { path: '', name:'home-renovations', component: WordpressGetter, props: { pageSlug: 'benefits-home-renovations' } },
			// { path: 'wallpaper-2', name:'home-renovations-wallpaper', component: WordpressGetter, props: {pageSlug: 'home-renovations-wallpaper-landing'}, menu:{member:"Wallpaper", public:"Wallpaper"} },
			// { path: 'wallpaper', name:'wallpaper', component: WordpressGetter, props: {pageSlug: 'home-renovations-wallpaper'} }
			// ]
			// },
			// { path: 'mortgages-insurance', component: WordpressGetter, props: { pageSlug: 'benefits-mortgages-insurance' }, menu: { public: 'Mortgages and Insurance', member: "Mortgages and Insurance" } },
			// { path: 'shopping-service', component: WordpressGetter, props: { pageSlug: 'benefits-shopping-service' }, menu: { public: 'Shopping Service', member: "Shopping Service" } },

			// { path: 'see-what-you-save', component: WordpressGetter, props: { pageSlug: 'benefits-see-what-you-save' }, menuTitle: 'See What You Save' }
		]
	},

	{  // About us Item
		path: '/about', component: EmptyView, menu: { public: 'About Us', member: "About Us"},
		children: [
			{ path: '', name: 'about', component: WordpressGetter, props: { pageSlug: 'our-story' }, menu:{ public: "Our Story", member: "Our Story" } },
			{ path: 'meet_the_team', name: 'meet-the-team', component: WordpressGetter, props: { pageSlug: 'meet-the-team' }, menu: { public: 'Our Team', member: 'Our Team' } },
			{
				path: "blog", component: EmptyView, menu: { public: 'Blogs', member: 'Blogs' },
				children:[
					{ path: '', name: 'blog', component: Blog, props: { pageSlug: 'blog' }},
					{ path: 'post/:postId', name: 'post', component: BlogPost}
				]
			},
			{ path: 'videos', name: 'about-videos', component: WordpressGetter, props: {pageSlug: 'about-videos'}, menu: {public: 'Videos', member: 'Videos'}},
			{ path: 'using_this_site', name: "using-this-site", component: WordpressGetter, props: {pageSlug: "using-this-site"}, menu: {public: "Using This Site", member: "Using This Site"}},
			{ path: '../faqs', name: 'about-faq', component: WordpressGetter, props: { pageSlug: 'faq' }, menu: { member: 'FAQs' } },
		]
	},
	
	// {
	// 	path: '/member-stories', component: EmptyView, menu: { public: "Member Stories" },
	// 	children:
	// 		[
	// 			{ path: '', name: 'member-stories', component: WordpressGetter, props: { pageSlug: 'member-stories' }, menu: { public: "Overview" } },
	// 			{ path: 'renovators', name: 'member-stories-renovators', component: WordpressGetter, props: { pageSlug: 'member-stories-renovators' }, menu: { public: "Renovators" } },
	// 			{ path: 'businesses', name: 'member-stories-businesses', component: WordpressGetter, props: { pageSlug: 'member-stories-businesses' }, menu: { public: "Businesses" } },
	// 			{ path: 'young-people', name: 'member-stories-young-people', component: WordpressGetter, props: { pageSlug: 'member-stories-young-people' }, menu: { public: "Young People" } },
	// 			{ path: 'families', name: 'member-stories-families', component: WordpressGetter, props: { pageSlug: 'member-stories-families' }, menu: { public: "Families" } },
	// 		]
	// },
	// {
	// 	path: '/about', component: EmptyView, menu: { member: 'About Us' },
	// 	children: [
	// 		{ path: '', name: 'about', component: WordpressGetter, props: { pageSlug: 'about' }, menu:{member:"Overview", public: "Overview"} },
	// 		{ path: 'meet-the-team', name: 'meet-the-team', component: WordpressGetter, props: { pageSlug: 'meet-the-team' }, menu: { member: 'Meet The Team', public: 'Meet The Team' } },
	// 		{ path: 'member-stories', name: 'about-member-stories', component: WordpressGetter, props: { pageSlug: 'member-stories' }, menu: { member: "Member Stories" } },
	// 		{
	// 		path: "blog", component: EmptyView, menu: { public: 'Blog', member: 'Blog' },
	// 			children:[
	// 			{ path: '', name: 'blog', component: Blog, props: { pageSlug: 'blog' }},
	// 			{ path: 'post/:postId', name: 'post', component: BlogPost}
	// 			]
	// 		},
	// 		{ path: 'videos', name: 'about-videos', component: WordpressGetter, props: {pageSlug: 'about-videos'}, menu: {public: 'Videos', member: 'Videos'}},
	// 	]
	// },
	{ path: '/price_request', name: 'get-a-price', component: PriceRequest, meta: { requiresLogin: true }	},
	
	{ path: '/contact', component: ContactPage, menu: { public: 'Contact Us', member: 'Contact Us' } },
	// {
	// 	path: '/help', component: EmptyView, menu: { public:"Help", member: "Help" },
	// 	children: [
	// 		{ path: '', name: "help", component: WordpressGetter, props: { pageSlug: 'using-this-site' } },
			// { path: 'contact', component: EmptyView, menu: { public: 'Contact Us', member: 'Contact Us' },
			// 	children: [
			// 		{ path: '', name: 'contact', component: ContactPage, props: { pageSlug: 'contact-top' } },
			// 		{ path: 'feedback', name: "feedback", component: FeedbackPage, props: { pageSlug: 'feedback-top-content' }, menu: {public: 'Feedback', member: 'Feedback'} },
			// 		{ path: 'feedback-thanks', name:'feedback-thanks', component: WordpressGetter, props: {pageSlug:'feedback-thanks'}}
			// 	]
			// },
	// 		{ path: 'using-this-site', name:'using-this-site', component: WordpressGetter, props: {pageSlug: 'using-this-site'}, menu:{public: 'Using This Site Tips', member:'Using This Site Tips'}},
	// 		{ path: 'payment-options', name:'payment-options', component:WordpressGetter, props:{pageSlug:'payment-options'}, menu:{public:'Payment Options', member:'Payment Options'}},
	// 		{ path: 'freight-costs', name:'freight-costs', component: WordpressGetter, props: {pageSlug: 'freight-costs'}, menu: {public: "Freight Costs", member: 'Freight Costs'} },
	// 		//FAQ's also in about us
	// 		{ path: 'opening-hours', name:'opening-hours', component: WordpressGetter, props:{pageSlug:'opening-hours'}, menu:{public: "Opening Hours", member:'Opening Hours'}},
	// 		{ path: 'shopping-with-us', name: 'help-shopping-with-us', component: WordpressGetter, props: { pageSlug: 'shopping-with-us' }, menu: { member: 'Shopping With Us' } },
	// 		{ path: 'faqs', name: 'help-faq', component: WordpressGetter, props: { pageSlug: 'about-faq' }, menu: { public: 'FAQs', member: 'FAQs' } },
	// 	]

	// },


	// { path: '/contact', component: EmptyView, menu: { public: 'Contact Us', member: 'Contact Us' },
	// 	children: [
	// 		{ path: '', name: 'contact', component: ContactPage, props: { pageSlug: 'contact' } },
	// 		{ path: 'feedback', name: "feedback", component: FeedbackPage,  menu: {public: 'Feedback', member: 'Feedback'} },
	// 		{ path: 'feedback-thanks', name:'feedback-thanks', component: WordpressGetter, props: {pageSlug:'feedback-thanks'} }	
	// 	]
	// },
	// { path: '/feedback', component: EmptyView, menu: {public: 'Feedback', member: 'Feedback'},
	//   children: [
	//     { path: '', name: "feedback", component: FeedbackPage },
	//     { path: 'feedback-thanks', name:'feedback-thanks', component: WordpressGetter, props: {pageSlug:'feedback-thanks'}}
	//   ]
	// },

	// { path: "/pet-caring", component: WordpressGetter, props: { pageSlug: 'pet-landing-page' } },
	// { path: "/pet-contest", name: "pet-contest-signup", component: PetSubmissionPage },
	{ path: "/deals", component: EmptyView, 
		children: [
			// { path: "accomodation", component: WordpressGetter, props: { pageSlug: "accomodation" }, meta: { requiresLogin: true } },
			{ path: "birthday", component: WordpressGetter, props: { pageSlug: "birthday" } },
			{ path: "bed", component: WordpressGetter, props: { pageSlug: "bed-deal" } },
		]
	},


	{
		path: '/signup', component: EmptyView, 
		children: [
			{ path: '', name: 'signup', component: Signup},
			{ path: 'gold', name: 'gold-signup', component: Signup},
			{ path: 'platinum', name: 'platinum-signup', component: WordpressGetter, props: { pageSlug: 'platinum' } }
		]
	},
	{ path: '/login', name: 'login', component: Login }, //show login page
	{ path: '/resetPassword', name: 'resetPassword', component: ResetPassword },
	{ path: '/forgotten', name: 'forgotten', component: ForgottenPassword },
	{ path: '/verifyEmail', name: 'verifyEmail', component: VerifyEmail },
	{ path: '/checkEmail', name: 'checkEmail', component: CheckEmail}, //page telling user to check their email

	{ path: '/rejoin-request', name: "rejoin-request", component: RejoinRequestPage },  // Page for returning users to request to rejoin at a given level

	//my account section
	{
		path: '/account', component: MyAccount, meta: { requiresLogin: true, breadcrumb: "My Account" },
		children:
			[
				{ path: '', name: 'account', component: Details },
				{ path: 'change-password', name: 'accountChangePassword', component: ChangePassword },
				{ path: 'purchases', name: 'accountPurchases', component: Purchases },
				{ path: 'membership', name: 'accountMembership', component: Membership },
				{ path: 'referrals', name: 'accountReferrals', component: Referrals },
				{ path: 'points', name: 'accountPoints', component: Points },
				{ path: 'favourites', name: 'accountFavourites', component: Favourites },
				{ path: 'gold', name: 'accountGoldUpgrade', component: GoldUpgrade },
				{ path: 'platinum', name: 'accountPlatinumUpgrade', component: WordpressGetter, props: { pageSlug: 'platinum' } },
				{ path: 'renew', name: 'accountMembershipRenewal', component: MembershipRenewal },
				{ path: 'preferences', name: 'accountPreferences', component: Preferences },
				{ path: 'completeAccount', name: 'accountCompleteAccount', component: CompleteAccount },
			]
	},

	//url for showing wordpress post previews, don't remove
	{ path: '/wordpressPreview/', component: WordpressPreviewGetter },


	//redirect old website pages to new one
	{ path: '/index.html', redirect: {name:'home'}},
	{ path: '/members', redirect: {name:'account'}},
	{ path: '/catalogue/index.html', redirect: {name: 'shop'}},
	{ path: '/catalogue/price-request.html', redirect: {name: 'get-a-price'}},
	{ path: '/benefits/catalog/price-request.html', redirect: { name: 'get-a-price' }},

	// { path: '/new-home', name: 'help-faq', component: WordpressGetter, props: { pageSlug: 'new-home-page' }},

	// Footer Links
	{ path: '/pledge', name: 'pledge', component: WordpressGetter, props: {pageSlug: 'pledge'}},
	{ path: '/terms-and-conditions', name:'terms-and-conditions', component: WordpressGetter, props: {pageSlug: 'terms-and-conditions'}},	
	{ path: '/home/goldupgrade', name:'terms-and-conditions', component: WordpressGetter, props: {pageSlug: 'home-goldupgrade'}},
	{ path: '/privacy-policy', name: 'privacy-policy', component: WordpressGetter, props: { pageSlug: 'privacy-policy' } },
	{ path: '/warranty-and-returns', name: 'warranty-and-returns', component: WordpressGetter, props: { pageSlug: 'warranty-and-returns' } },
	{ path: '/returns', name: 'returns', component: Returns, meta: { requiresLogin: true } },
	{ path: '/become-a-supplier', name: 'become-a-supplier', component: WordpressGetter, props: { pageSlug: 'become-a-supplier' } },
	{ path: '/opening-hours', name:'opening-hours', component: WordpressGetter, props:{pageSlug:'opening-hours'} },
	// End Footer Links	

	{ path: "/not-found", name: '404', component: PageNotFound }, //Page not found go to
	{ path: "*", component: PageNotFound } //default page when no other route is matched
]


// 3. Create the router instance and pass the `routes` option
const router = new VueRouter({
    routes, // short for `routes: routes`
    mode: 'history',
    //TODO set this to root for deployment to live
    base: '/c2/',
    scrollBehavior(to, from, savedPosition) {
        //don't scroll on query parameter changes
        if (to.path != from.path) {
            if (savedPosition) {
                return savedPosition
            } else {
                return { x: 0, y: 0 }
            }
        }
    }
})

// Setup navigation guards to ckeck for logged in before allowing navigation
router.beforeEach((to, from, next) => {
    document.getElementsByTagName("body")[0].classList="";
    if (to.matched.some(record => record.meta.requiresLogin)) {
        //if page, or parent has requiresLogin meta, then check if logged in
        if (store.state.auth.loggedIn === false) {
            next({ name: 'login', query: { redirect: to.path, state: "authRequired" } })
        } else if (store.state.auth.loggedIn === null) {
            //if login state unknown, check, then transition to login page if nessecary.
            //Fixes visiting login when user visits page directly by URL
            store.dispatch("auth/checkLogin").then(loggedIn => {
                if (!loggedIn) {
                    next({ name: 'login', query: { redirect: to.path, state: "authRequired" } })
                }
            })
        }
    }

    if("s" in to.query && to.name == "home") {
        next({ name: 'search', query: { s: to.query.s } });
    }

    // Hide the chatbox on first page load if it's not on the pages that we want it to show on.
    window.purechatApi.on('chatbox:ready', 
        function () {
            if (pureChatPages.indexOf(to.name) == -1 && to.name != from.name) {
                window.purechatApi.set("chatbox.visible", false);
            }
        }
    )
    
    // Purechat visibility toggle on navigation.
    if(window.purechatApi.set != null){
        if (pureChatPages.indexOf(to.name) == -1 && to.name != from.name) {
            window.purechatApi.set("chatbox.visible", false);
        } else {
            window.purechatApi.set("chatbox.visible", true);
        }
    }
    next() //if authourised then continue as normal
})


export default router
